<template>
    <div class="main-container" id="anchor-fullkit">
        <div
            class="fullkit-section">
            <h2>{{ $t("press.fullkitSection.fullkit").toUpperCase() }}</h2>
            <p>{{ $t("press.fullkitSection.fullkitText") }}</p>
            <a
                :href="pressKitZipDownload"
                target="_blank"
                download>
                <CustomButton>
                    {{ $t("press.fullkitSection.getPressKit") }}
                </CustomButton>
            </a>
        </div>
    </div>
</template>

<script>
import CustomButton from '@/components/press/CustomButton.vue'

export default {
    components: {
        CustomButton
    },
    computed: {
        pressKitZipDownload () {
            return 'https://drive.google.com/drive/folders/1bxtmZg17_zpbMyB2p7Smsy82OIns_Uue'
        }
    }
}
</script>

<style lang="scss" scoped>
  .main-container {
    padding: 100px 0px;
    background-color: $grey-15;
    @include breakpoint($device: mobile) {
        padding: 80px 0px;
    }
    a {
      text-decoration: none;
      color: $blue-2 !important;
      font-weight: 600;
    }
    p {
        margin-bottom: 0;
    }
    @include breakpoint($min: desktop-sm) {
      & > div:not(:first-child) {
        margin: auto;
        max-width: 75vw;
      }
    }
    .top-section {
      .sandbox-brand-page:before {
        content: "";
        position: absolute;
        z-index: -1;
        opacity: 0.4;
        width: 100%;
        height: 100%;
        background: url("https://presskit.sandbox.game/Biome_Jungle.jpg")
          no-repeat 0 0;
        background-size: cover;
      }
      .sandbox-brand-page {
        @include flex(column, center, center);
        position: relative;
        z-index: -2;
        height: 200px;
        max-height: 200px;
        margin-top: 60px;
        .title {
          color: white;
          margin-top: 60px;
          font-size: 70px;
          font-family: "Montserrat Bold";
        }
        p {
          padding: 0px 200px 50px 200px;
          text-align: center;
          font-size: 21px;
        }
      }
    }
    .fullkit-section {
      @include flex(column, center, center);
      h2 {
        font-size: 50px;
        font-weight: Bold;
      }
      p {
        font-size: 24px;
        line-height: 27px;
        text-align: center;
        color: #a0a4a7;
      }
      a {
        margin-top: 5vh;
        margin-bottom: 0px;
      }
    }
  }
@include breakpoint($device: touch) {
  .main-container {
    scroll-behavior: smooth;
    .top-section {
      .top-bar {
        display: none;
      }
      .sandbox-brand-page:before {
        content: "";
        position: absolute;
        z-index: -1;
        opacity: 0.4;
        width: 100%;
        height: 100%;
        background: url("https://presskit.sandbox.game/Biome_Jungle.jpg")
          no-repeat 0 0;
        background-size: cover;
      }
      .sandbox-brand-page {
        @include flex(column, center, center);
        position: relative;
        z-index: -2;
        height: 148px;
        .title {
          color: white;
          margin-top: 20px;
          font-size: 25px;
          font-family: "Montserrat Bold";
        }
        p {
          text-align: center;
          margin-top: 20px;
          font-size: 12px;
        }
      }
    }
    .fullkit-section {
      @include flex(column, center, center);
      margin-right: 20px;
      margin-left: 20px;
      h2 {
        font-size: 25px;
        font-weight: Bold;
      }
      p {
        text-align: center;
        margin-top: 20px;
        font-size: 15px;
      }
      a {
        margin: 5vh 0 0vh 0;
      }
    }
  }
}
</style>
